import { Http } from '../../../support';

const initialState = {
  data: [],
  busy: false,
  rotating: false,
};

const setPartialState = (store, data) => {
  store.setState((state) => {
    state.apikeys = { ...data };
  });
};

const info = async (store, id, params = {}) => {
  store.setState((state) => {
    state.cuenta.apikeys.busy = true;
  });

  try {
    const headers = {
      'X-Tenancy': 'fa/live',
    };

    const response = await Http.get(`api/empresas/${id}`, { params, headers });

    store.setState((state) => {
      state.cuenta.apikeys.data = response.data;
    });
  } catch (error) {
    store.setState((state) => {
      state.cuenta.apikeys.error = error.data || error;
    });
  } finally {
    store.setState((state) => {
      state.cuenta.apikeys.busy = false;
    });
  }
};

const rotate = async (store, type) => {
  store.setState((state) => {
    state.cuenta.apikeys.rotating = type;
  });

  try {
    const headers = {
      'X-Tenancy': 'fa/live',
    };

    const params = {
      'api-key': type,
    };

    const response = await Http.patch(`auth/me/api-keys`, params, { headers });

    store.setState((state) => {
      state.cuenta.apikeys.data = response.data;
    });
  } catch (error) {
    store.setState((state) => {
      state.cuenta.apikeys.error = error.data || error;
    });
  } finally {
    store.setState((state) => {
      state.cuenta.apikeys.rotating = undefined;
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    state.apikeys = { ...initialState };
  });
};

const ApiKeysStore = {
  state: { ...initialState },
  actions: { setPartialState, info, rotate, reset },
};

export default ApiKeysStore;
